export class FunctionDto {
  entityId: string;
  function: string;
  id: string;
  mode: string;

  constructor(d: FunctionDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
